export const tabsData = [
  {
    label: "Main Skills",
    sections: [
      {
        header: "Web Developer",
        context:
          "Developed varoius fully responsive web applications using ReactJS and Redux.",
      },
      {
        header: "Mobile Developer",
        context:
          "Knowledge of mobile development using React Native and Android Studio.",
      },
      {
        header: "Other Programming Languages",
        context: "Java, C, C++, C#, Python, PHP, SQL, HTML, CSS, NodeJS.",
      },
    ],
  },
  {
    label: "Education & Certification",
    sections: [
      {
        header: "Practical Software Engineer",
        context: "2.5 years of study in software engineering.",
      },

      {
        header: "Udamy Courses",
        context:
          "React - The Complete Guide (incl Hooks, React Router, Redux) by Maximilian Schwarzmüller" +
          "," +
          " " +
          "The Complete 2021 Web Development Bootcamp by Dr.Anjela Yu, and more...",
      },
    ],
  },
  {
    label: "Hobbies",
    sections: [
      {
        header: "Music",
        context: "Music, Music And More Music",
      },
      {
        header: "Video Games",
        context: "Really love gaming!",
      },
      {
        header: "Playing Guitars",
        context: "Bass & Electric Guitars!",
      },
    ],
  },
];
